import { Component } from '@angular/core';
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-important-items-nutricion',
  standalone: true,
  imports: [
    NgForOf
  ],
  templateUrl: './important-items-nutricion.component.html',
  styleUrl: './important-items-nutricion.component.css'
})
export class ImportantItemsNutricionComponent {
  listItems = [
    {
      texto: "Promueve la salud y el bienestar general de los colaboradores.",
    },
    {
      texto: "Previene enfermedades relacionadas con la alimentación, como obesidad, diabetes o hipertensión."
    },
    {
      texto: "Mejora la energía y productividad en el trabajo."
    },
    {
      texto: "Fomenta hábitos alimenticios saludables, brindando un enfoque individualizado."
    }
  ]

}
